import { render, staticRenderFns } from "./YearMonthControl.vue?vue&type=template&id=ff770bf6&scoped=true&"
import script from "./YearMonthControl.vue?vue&type=script&lang=ts&"
export * from "./YearMonthControl.vue?vue&type=script&lang=ts&"
import style0 from "./YearMonthControl.vue?vue&type=style&index=0&id=ff770bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff770bf6",
  null
  
)

export default component.exports